/* @generated */

// ../src/accordion/accordion.tsx
import * as React6 from "react";
import classnames2 from "classnames";

// ../src/accordion/context.tsx
import * as React from "react";
var defaultValue = {
  expandedPanels: /* @__PURE__ */ new Set([]),
  variant: "standard",
  headerTagName: "h1"
};
var itemDefaultValue = {
  itemId: "",
  isDisabled: false,
  headerA11yProps: { id: "", ariaControls: "" },
  setHeaderA11yProps: () => {
  }
};
var headerDefaultValue = {
  size: "medium"
};
var AccordionContext = React.createContext(defaultValue);
var AccordionItemContext = React.createContext(itemDefaultValue);
var AccordionHeaderContext = React.createContext(headerDefaultValue);

// ../src/accordion/item.tsx
import * as React2 from "react";
import classNames from "classnames";

// ../src/accordion/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var accordionHeader = "dig-2vtwos9_20-11-1";
var accordionHeaderChevron = "dig-2vtwose_20-11-1";
var accordionHeaderLeftAccessory = "dig-2vtwosf_20-11-1";
var accordionHeaderRightAccessory = "dig-2vtwosj_20-11-1";
var accordionHeaderTitle = "dig-2vtwosg_20-11-1";
var accordionHeaderTitleBadge = "dig-2vtwosi_20-11-1";
var accordionHeaderTitleContainer = "dig-2vtwosh_20-11-1 dig-2vtwos0_20-11-1";
var accordionHeaderTriggerRecipe = _7a468({ defaultClassName: "dig-2vtwosa_20-11-1", variantClassNames: { spacing: { small: "dig-2vtwosb_20-11-1", medium: "dig-2vtwosc_20-11-1", large: "dig-2vtwosd_20-11-1" } }, defaultVariants: { spacing: "medium" }, compoundVariants: [] });
var accordionItemRecipe = _7a468({ defaultClassName: "dig-2vtwos0_20-11-1", variantClassNames: { isActive: { true: "dig-2vtwos5_20-11-1", false: "dig-2vtwos6_20-11-1" }, isDisabled: { true: "dig-2vtwos7_20-11-1", false: "dig-2vtwos8_20-11-1" } }, defaultVariants: { isActive: false, isDisabled: false }, compoundVariants: [] });
var accordionPanelRecipe = _7a468({ defaultClassName: "dig-2vtwosk_20-11-1", variantClassNames: { spacing: { small: "dig-2vtwosl_20-11-1", medium: "dig-2vtwosm_20-11-1", large: "dig-2vtwosn_20-11-1" } }, defaultVariants: { spacing: "medium" }, compoundVariants: [] });
var accordionRecipe = _7a468({ defaultClassName: "dig-2vtwos1_20-11-1 dig-2vtwos0_20-11-1", variantClassNames: { variant: { blades: "dig-2vtwos2_20-11-1", standard: "dig-2vtwos3_20-11-1" } }, defaultVariants: { variant: "standard" }, compoundVariants: [] });

// ../src/accordion/item.tsx
var Item = ({
  itemId,
  className,
  isDisabled = false,
  children,
  ...rest
}) => {
  const { expandedPanels } = React2.useContext(AccordionContext);
  const [headerA11yProps, setHeaderA11yProps] = React2.useState({
    id: "",
    ariaControls: ""
  });
  const isActive = expandedPanels.has(itemId);
  const cls = classNames(
    "dig-Accordion-item",
    {
      "dig-Accordion-item--isActive": isActive,
      "dig-Accordion-item--disabled": isDisabled
    },
    accordionItemRecipe({ isActive, isDisabled }),
    className
  );
  return /* @__PURE__ */ React2.createElement(
    AccordionItemContext.Provider,
    {
      value: {
        itemId,
        isDisabled,
        headerA11yProps,
        setHeaderA11yProps
      }
    },
    /* @__PURE__ */ React2.createElement("div", { className: cls, ...rest }, children)
  );
};

// ../src/accordion/panel.tsx
import classnames from "classnames";
import * as React3 from "react";
var Panel = ({ children, spacing = "medium", className, ...rest }) => {
  const { itemId, headerA11yProps } = React3.useContext(AccordionItemContext);
  const { expandedPanels } = React3.useContext(AccordionContext);
  const isActive = expandedPanels.has(itemId);
  const cls = classnames(
    "dig-Accordion-panel",
    `dig-Accordion-panel-spacing--${spacing}`,
    accordionPanelRecipe({ spacing }),
    className
  );
  return /* @__PURE__ */ React3.createElement(
    "div",
    {
      className: cls,
      ...rest,
      role: "region",
      id: headerA11yProps.ariaControls,
      "aria-labelledby": headerA11yProps.id,
      "aria-hidden": !isActive,
      hidden: !isActive
    },
    children
  );
};

// ../src/accordion/header.tsx
import classNames2 from "classnames";
import * as React4 from "react";

// ../src/accordion/utils.ts
var getDefaultHeaderId = (itemId) => {
  return `${itemId}-header-id`;
};
var getDefaultHeaderAriaControls = (itemId) => {
  return `${itemId}-panel-id`;
};

// ../src/accordion/header.tsx
var Header = ({
  size = "medium",
  spacing = "medium",
  id,
  "aria-controls": ariaControls,
  className,
  children,
  ...rest
}) => {
  const { expandedPanels, headerTagName: HeaderTagName } = React4.useContext(AccordionContext);
  const { itemId, isDisabled, setHeaderA11yProps } = React4.useContext(AccordionItemContext);
  const isActive = expandedPanels.has(itemId);
  const cls = classNames2(
    "dig-Accordion-header",
    `dig-Accordion-header-size--${size}`,
    `dig-Accordion-header-spacing--${spacing}`,
    accordionHeader,
    className
  );
  const headerId = React4.useMemo(() => {
    return id || getDefaultHeaderId(itemId);
  }, [itemId, id]);
  const headerAriaControls = React4.useMemo(() => {
    return ariaControls || getDefaultHeaderAriaControls(itemId);
  }, [itemId, ariaControls]);
  React4.useEffect(() => {
    setHeaderA11yProps({ id: headerId, ariaControls: headerAriaControls });
  }, [headerId, headerAriaControls, setHeaderA11yProps]);
  return /* @__PURE__ */ React4.createElement(AccordionHeaderContext.Provider, { value: { size } }, /* @__PURE__ */ React4.createElement(HeaderTagName, { className: cls }, /* @__PURE__ */ React4.createElement(
    "button",
    {
      className: classNames2(
        "dig-Accordion-header-trigger",
        accordionHeaderTriggerRecipe({ spacing })
      ),
      id: headerId,
      "aria-controls": headerAriaControls,
      ...rest,
      tabIndex: 0,
      "aria-expanded": isActive,
      "aria-disabled": isDisabled,
      disabled: isDisabled
    },
    children
  )));
};

// ../src/accordion/header_content.tsx
import * as React5 from "react";
import { Text } from "@dropbox/dig-components/typography";
import { UIIcon } from "@dropbox/dig-icons";
import { ChevronDownLine, ChevronUpLine } from "@dropbox/dig-icons/assets";
import classNames3 from "classnames";
var HeaderContent = ({
  withTitle,
  withLeftAccessory,
  withTitleRightAccessory,
  withSubtitle
}) => {
  const { variant, expandedPanels } = React5.useContext(AccordionContext);
  const { itemId, isDisabled } = React5.useContext(AccordionItemContext);
  const { size } = React5.useContext(AccordionHeaderContext);
  const isActive = expandedPanels.has(itemId);
  const headerTitleColor = React5.useMemo(() => {
    if (isDisabled) {
      return "disabled";
    } else if (variant === "blades" && !isActive) {
      return "faint";
    } else {
      return "standard";
    }
  }, [isDisabled, variant, isActive]);
  const headerSubtitleColor = React5.useMemo(() => {
    if (isDisabled) {
      return "disabled";
    } else {
      return "faint";
    }
  }, [isDisabled]);
  return /* @__PURE__ */ React5.createElement(React5.Fragment, null, withLeftAccessory && /* @__PURE__ */ React5.createElement(
    "div",
    {
      className: classNames3(
        "dig-Accordion-header-left-accessory",
        accordionHeaderLeftAccessory
      )
    },
    withLeftAccessory
  ), /* @__PURE__ */ React5.createElement(
    "div",
    {
      className: classNames3(
        "dig-Accordion-header-title-container",
        accordionHeaderTitleContainer
      )
    },
    /* @__PURE__ */ React5.createElement(
      "div",
      {
        className: classNames3(
          "dig-Accordion-header-title-badge-container",
          accordionHeaderTitleBadge
        )
      },
      /* @__PURE__ */ React5.createElement(
        Text,
        {
          isBold: true,
          size,
          variant: "label",
          className: classNames3("dig-Accordion-header-title", accordionHeaderTitle),
          color: headerTitleColor
        },
        withTitle
      ),
      withTitleRightAccessory && /* @__PURE__ */ React5.createElement(
        "div",
        {
          className: classNames3(
            "dig-Accordion-header-title-right-accessory",
            accordionHeaderRightAccessory
          )
        },
        withTitleRightAccessory
      )
    ),
    /* @__PURE__ */ React5.createElement(
      Text,
      {
        size,
        color: headerSubtitleColor,
        variant: "label",
        className: "dig-Accordion-header-subtitle"
      },
      withSubtitle
    )
  ), variant === "standard" && /* @__PURE__ */ React5.createElement("div", { className: classNames3("dig-Accordion-header-chevron", accordionHeaderChevron) }, /* @__PURE__ */ React5.createElement(UIIcon, { src: isActive ? ChevronUpLine : ChevronDownLine, size: "small" })));
};

// ../src/accordion/accordion.tsx
var Accordion = ({
  className,
  children,
  variant = "standard",
  expandedPanel = "",
  expandedPanels = [],
  headerTagName = "h2",
  ...rest
}) => {
  const cls = classnames2(
    "dig-Accordion",
    `dig-Accordion--${variant}`,
    accordionRecipe({ variant }),
    className
  );
  return /* @__PURE__ */ React6.createElement(
    AccordionContext.Provider,
    {
      value: {
        expandedPanels: variant === "blades" ? /* @__PURE__ */ new Set([expandedPanel]) : new Set(expandedPanels),
        variant,
        headerTagName
      }
    },
    /* @__PURE__ */ React6.createElement("div", { className: cls, ...rest }, children)
  );
};
Accordion.displayName = "Accordion";
Accordion.Item = Item;
Accordion.Header = Header;
Accordion.HeaderContent = HeaderContent;
Accordion.Panel = Panel;
export {
  Accordion
};
